import {
  CleanedUpPlaylistAPIProps,
  CleanedUpPlaylistTeaserAPIProps,
  PlaylistAPIProps,
} from './types'

const getNextVideoInPlaylist = (
  items: CleanedUpPlaylistTeaserAPIProps[],
  currentId: string,
  startFromTheFirst = false
): CleanedUpPlaylistTeaserAPIProps | null => {
  const currentIndex = items?.findIndex(
    (item) => item?.link?.targetArticleId === currentId
  )

  // if the video isn't in the playlist, just play the first one
  if (currentIndex === -1) {
    return items[0]
  }

  // the last item in the playlist
  if (currentIndex + 1 === items?.length) {
    return startFromTheFirst ? items[0] : null
  }

  return items?.[currentIndex + 1] || null
}

const cleanUpPlaylistData = (
  data: Pick<PlaylistAPIProps, 'title' | 'isPlayingId' | 'items'>
): CleanedUpPlaylistAPIProps | undefined => {
  if (!(data?.items?.length > 0)) {
    return
  }

  return data.items.reduce(
    (acc, item) => {
      if (item?.video) {
        acc.items.push({
          ...item,
          isActive: item.articleId === data.isPlayingId,
        } as CleanedUpPlaylistTeaserAPIProps)
      }

      return acc
    },
    {
      ...data,
      items: [],
    } as CleanedUpPlaylistAPIProps
  )
}

export { getNextVideoInPlaylist, cleanUpPlaylistData }
